export const DateFormats = {
	UI: {
		TimeSlotInput: 'h:mm A',
		Date: 'MMMM Do YYYY',
	},

	API: {
		DateTime: 'YYYY-MM-DD[T]HH:mm',
		Date: 'YYYY-MM-DD',
		Time: 'HH:mm',
	},
};
